/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ContactTranscriptSummary
 */
export interface ContactTranscriptSummary {
    /**
     * 
     * @type {string}
     * @memberof ContactTranscriptSummary
     */
    text?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContactTranscriptSummary
     */
    dateCreated?: Date;
}

/**
 * Check if a given object implements the ContactTranscriptSummary interface.
 */
export function instanceOfContactTranscriptSummary(value: object): boolean {
    return true;
}

export function ContactTranscriptSummaryFromJSON(json: any): ContactTranscriptSummary {
    return ContactTranscriptSummaryFromJSONTyped(json, false);
}

export function ContactTranscriptSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactTranscriptSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
    };
}

export function ContactTranscriptSummaryToJSON(value?: ContactTranscriptSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'text': value['text'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
    };
}

